export default {"src":"/_next/static/media/Website.305a4368.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};